export default __webpack_public_path__ + "assets/beaker-large-component.a6f8e16f.svg";